import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class ArtilleryBomb extends PhysicalThing {
	static key = "ArtilleryBomb";
	constructor(xy: XY) {
		super(xy, false);
	}

	override getZOrder(): number {
		return ZOrder.AIR;
	}

	static deserialize(data: any): ArtilleryBomb {
		const b = new ArtilleryBomb(deserializeXY(data.xy));
		b.visualId = data.visualId;
		return b;
	}
}
